import React from 'react'
import { route } from "@helpers"
import useAuth from "@hooks/useAuth"
import { Redirect, Route, RouteProps } from "react-router-dom"

/**
 * Doesn't allow logged in users to access children.
 */
export default function auth() {
    return ({ children, component, ...props }: RouteProps) => {
        const { user } = useAuth<Helpers.User>()
        if (user) return <Redirect to={route(user.role.name)} />
        if (component) return <Route {...props} component={component} />
        return <Route {...props}>{children}</Route>
    }
}